import React from 'react';
import type { PayPeriod } from '../types/payment';
import { formatDateRange } from '../utils/paymentConfig';

/** Decorative stand-in for the Salesforce record page the modal launches from. */
export function RecordPageBackdrop({
  payPeriod
}: {
  payPeriod: PayPeriod;
}) {
  return <div aria-hidden="true" className="absolute inset-0 overflow-hidden bg-ink-100" data-id="element-177" data-mp="ziyznigcq08k">
      <div className="h-12 w-full bg-brand-800" data-id="element-178" data-mp="ujm2o4vrncs9" />
      <div className="mx-auto max-w-6xl px-8 py-6" data-id="element-179" data-mp="ukdztk50hikn">
        <div className="rounded-lg border border-ink-200 bg-white px-6 py-4 shadow-card" data-id="element-180" data-mp="psw00zeq5o19">
          <p className="text-xs uppercase tracking-wide text-ink-400" data-id="element-181" data-mp="pr2ob5p98dme">
            Employee Pay Period
          </p>
          <p className="mt-1 text-xl font-semibold text-ink-900" data-id="element-182" data-mp="fuzq2axiwz4q">{payPeriod.name}</p>
          <p className="numeric mt-1 text-sm text-ink-500" data-id="element-183" data-mp="bt4or6flelqy">
            {formatDateRange(payPeriod.startDate, payPeriod.endDate)} ·{' '}
            {payPeriod.employeeRole}
          </p>
        </div>
        <div className="mt-5 grid grid-cols-3 gap-5" data-id="element-184" data-mp="s34tcxh7cq6j">
          {[0, 1, 2].map(column => <div key={column} className="space-y-3 rounded-lg border border-ink-200 bg-white p-5 shadow-card" data-id="element-185" data-mp="wtuyc9lpur0p">
              <div className="h-3 w-24 rounded bg-ink-200" data-id="element-186" data-mp="j3rgrvxs7lhl" />
              <div className="h-2.5 w-full rounded bg-ink-100" data-id="element-187" data-mp="n3s5qaiibf2w" />
              <div className="h-2.5 w-5/6 rounded bg-ink-100" data-id="element-188" data-mp="n1z08yjmr0wh" />
              <div className="h-2.5 w-2/3 rounded bg-ink-100" data-id="element-189" data-mp="1aupan3bvxc4n" />
              <div className="h-2.5 w-4/5 rounded bg-ink-100" data-id="element-190" data-mp="1fsh0zswvsq6q" />
            </div>)}
        </div>
      </div>
    </div>;
}